lmApp
  .controller('InstanceController', ['$scope', '$rootScope', '$templateCache', '$compile', '$routeParams', '$location', 'ModalWindowService', 'ToastService', 'ManagerResource', 'TimezoneService', 'OperatorService', 'CronService', 'ReplicationResource',
    function ($scope, $rootScope, $templateCache, $compile, $routeParams, $location, ModalWindowService, ToastService, ManagerResource, TimezoneService, OperatorService, CronService, ReplicationResource) {
      $scope.loading = false;

      $scope.replications = [];
      $scope.replication = {};
      $scope.activeReplication= {};

      $scope.totalLive = 0;
      $scope.totalVOD = 0;

      $scope.croneConfig = {
        options: {allowMinute: false, allowHour: false, allowYear: false}
      };
      $scope.croneInitTime = '0 5 * * *';

      $scope.resources = [
        {
          id: 0,
          'ext_id': 'channels',
          'title': 'Сhannels'
        },
        {
          id: 1,
          'ext_id': 'movies',
          'title': 'Movies'
        },
        {
          id: 2,
          'ext_id': 'series',
          'title': 'Series'
        },
        {
          id: 3,
          'ext_id': 'packages',
          'title': 'Packages'
        },
        {
          id: 4,
          'ext_id': 'genres',
          'title': 'Genres'
        },
        {
          id: 5,
          'ext_id': 'categories',
          'title': 'Categories'
        },
        {
          id: 6,
          'ext_id': 'countries',
          'title': 'Countries'
        },
        {
          id: 7,
          'ext_id': 'epg-channels',
          'title': 'EPG Channels'
        },
        {
          id: 8,
          'ext_id': 'epg-sources',
          'title': 'EPG Sources'
        }
      ];

      var resourceMap = {};
      for (var i = 0; i < $scope.resources.length; i++) {
        resourceMap[$scope.resources[i].ext_id] = i;
      }

      var jsonReplicationToNorm = function (replication) {
        var processed = {
          id: replication.id,
          createTime: replication.create_time,
          updateTime: replication.update_time,
          name: replication.name,
          type: replication.type,
          scheduleTime: replication.cron,
          syncSchedule: CronService.cronTimeToText(replication.cron),
          token: replication.access_token,
          nextRunTime: replication.next_run_time,
          resources: [],
          checkedOperator: {
            valid: false,
            operator: ''
          },
          lastRun: {
            runTime: null,
            state: '',
            error: ''
          },
          runs: [],
          sync: false
        };
        for (var i = 0; i < replication.elements.length; i++) {
          if (resourceMap.hasOwnProperty(replication.elements[i])) {
            processed.resources.push($scope.resources[resourceMap[replication.elements[i]]]);
          }
        }
        if (replication.last_run !== undefined) {
          processed.lastRun.runTime = replication.last_run.create_time;
          processed.lastRun.state = replication.last_run.state;
          processed.lastRun.error = replication.last_run.error;
        }
        return processed;
      };

      var jsonReplicationRunToNorm = function(run) {
        return {
          id: run.id,
          runTime: run.create_time,
          lastUpdateTime: run.update_time,
          state: run.state,
          error: run.error
        };
      };

      var normReplicationToJson = function(replication) {
        var processed = {
          name: replication.name,
          type: replication.type,
          access_token: replication.token,
          cron: replication.scheduleTime,
          elements: []
        };
        for (var i = 0; i < replication.resources.length; i++) {
          processed.elements.push(replication.resources[i].ext_id);
        }
        return processed;
      };

      // Timezone
      var timezone = _.find(TimezoneService.Timezones, {title: 'UTC'});
      $scope.tz = timezone.title;
      ManagerResource.get().$promise
          .then(function (result) {
            if (result.length !== 0) {
              var manager = _.find(result, {username: $rootScope.globals.currentUser.username});
              if (manager) {
                timezone = _.find(TimezoneService.Timezones, {title: manager.ui_timezone || 'UTC'});
                $scope.tz = timezone.title;
              }
            }
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
          });

      $scope.convertTime = function (dt) {
        return TimezoneService.addTimezoneToDate(dt, timezone)
      };

      //
      $scope.getReplications = function() {
        if ($scope.loading) return;

        $scope.replications = [];

        $rootScope.showLinearProgress('#replicationLoader');
        $scope.loading = true;

        ReplicationResource.get().$promise
            .then(function (replications) {
              for (var i = 0; i < replications.length; i++) {
                $scope.replications.push(jsonReplicationToNorm(replications[i]))
              }

              if ($scope.replications.length && $scope.routeReplicationId) {
                var replication = _.find($scope.replications, {id: $scope.routeReplicationId});
                if (replication) {
                  $scope.setActiveReplication(replication);
                }
              }

              $scope.loading = false;
              $rootScope.hideLinearProgress('#replicationLoader');
            })
            .catch(function (reason) {
              $scope.loading = false;
              $rootScope.hideLinearProgress('#replicationLoader');
              $rootScope.debugInfo(reason, 'silent');
              ToastService.Small({
                title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                color: 'amber',
                icon: 'server-off',
                blocked: true
              }, 1000 * 3);
            });
      };

      $scope.getToken = function() {
        $scope.replication.loading = true;
        $scope.replication.authError = '';
        return OperatorService.GetToken($scope.replication.login, $scope.replication.password)
            .then(function (result) {
              if (result.error && result.error.message) {
                $scope.replication.authError = result.error.message;
              }
              if (result.access_token) {
                $scope.replication.token = result.access_token;
                $scope.checkToken();
              }
              $scope.replication.loading = false;
            })
            .catch(function (reason) {
              $scope.replication.authError = 'invalid credentials';
              $scope.replication.loading = false;
            });
      };

      $scope.checkToken = function() {
        $scope.replication.loading = true;
        $scope.replication.authError = '';
        return OperatorService.CheckToken($scope.replication.token)
            .then(function (result) {
              $scope.replication.checkedOperator.valid = true;
              $scope.replication.checkedOperator.operator = result.data.ext_id;
              $scope.replication.loading = false;
            })
            .catch(function (reason) {
              $scope.replication.loading = false;
              $scope.replication.checkedOperator.valid = false;
            });
      };

      $scope.editReplication = function(replication) {
        if ($scope.loading) return;

        $scope.replicationValidateErrors = {};
        $scope.replication = {
          name: '',
          token: '',
          checkedOperator: {
            valid: null,
            operator: ''
          },
          type: 'push',
          resources: [],
          scheduleTime: '0 5 * * *',
          loading: false,
          showLoginForm: false,
          login: '',
          password: '',
          authError: ''
        };

        var update = false;
        if (replication !== undefined) {
          update = true;
          $scope.replication.id = replication.id;
          $scope.replication.name = replication.name;
          $scope.replication.token = replication.token;
          $scope.replication.checkedOperator.valid = replication.checkedOperator.valid;
          $scope.replication.checkedOperator.operator = replication.checkedOperator.operator;
          $scope.replication.type = replication.type;
          $scope.replication.resources = replication.resources;
          $scope.replication.scheduleTime = replication.scheduleTime;
        }

        $scope.croneInitTime = $scope.replication.scheduleTime;

        var inner = $templateCache.get('add-instance.html');
        inner = $compile(inner)($scope);

        ModalWindowService.Open({
          content: inner,
          keyboard: true,
          actions: [
            {
              title: update ? 'Save' : 'Create',
              color: 'green',
              check: function () {
                var valid = true;
                if (!$scope.replication.checkedOperator.valid) {
                  $scope.replication.checkedOperator.valid = false;
                  valid = false;
                }
                $scope.replicationValidateErrors = {};
                if (!_.trim($scope.replication.name)) {
                  $scope.replicationValidateErrors.name = true;
                  valid = false;
                }
                if ($scope.replication.resources.length === 0) {
                  $scope.replicationValidateErrors.resources = true;
                  valid = false;
                }
                return valid;
              },
              fn: function () {
                if (update === true) {
                  ReplicationResource.update({id: $scope.replication.id}, normReplicationToJson($scope.replication)).$promise
                    .then(function (response) {
                      updateActiveReplication($scope.replication, response.data);
                      ToastService.Small({
                        title: 'The replication has been updated',
                        color: 'green',
                        icon: 'plus'
                      }, 20 * 1000);
                      return response
                    })
                    .catch(function (reason) {
                      ToastService.Small({
                        title: 'Failed to update replication: ' + _.get(reason, 'data.error.message', 'server error'),
                        color: 'red',
                        icon: 'delete'
                      }, 30 * 1000);
                    });
                } else {
                  ReplicationResource.create(normReplicationToJson($scope.replication)).$promise
                    .then(function (response) {
                      $scope.replications.push(jsonReplicationToNorm(response.data));
                      ToastService.Small({
                        title: 'The replication has been added',
                        color: 'green',
                        icon: 'plus'
                      }, 20 * 1000);
                      return response
                    })
                    .catch(function (reason) {
                      ToastService.Small({
                        title: 'Failed to create replication: ' + _.get(reason, 'data.error.message', 'server error'),
                        color: 'red',
                        icon: 'delete'
                      }, 30 * 1000);
                    });
                }
              }
            },
            {
              title: 'Cancel',
              color: 'red',
              fn: function () {
              }
            }
          ]
        });
      };

      var updateActiveReplication = function(source, replication) {
        var processed = jsonReplicationToNorm(replication);
        $scope.activeReplication.updateTime = processed.updateTime;
        $scope.activeReplication.name = processed.name;
        $scope.activeReplication.type = processed.type;
        $scope.activeReplication.scheduleTime = processed.scheduleTime;
        $scope.activeReplication.syncSchedule = processed.syncSchedule;
        $scope.activeReplication.token = processed.token;
        $scope.activeReplication.nextRunTime = processed.nextRunTime;
        $scope.activeReplication.resources = processed.resources;
        $scope.activeReplication.checkedOperator.valid = true;
        $scope.activeReplication.checkedOperator.operator = source.checkedOperator.operator;
      };

      $scope.sync = function($event, replication) {
        $event.stopPropagation();
        $event.preventDefault();
        replication.sync = true;

        ReplicationResource.syncNow({id: replication.id}).$promise
            .then(function (response) {
              var updated = jsonReplicationToNorm(response.data);
              if ($scope.isActiveReplicationSet()) {
                $scope.setActiveReplication(updated);
              }

              for (var i = 0; i < $scope.replications.length; i++) {
                if ($scope.replications[i].id === updated.id) {
                  $scope.replications[i].nextRunTime = updated.nextRunTime;
                  $scope.replications[i].lastRun = updated.lastRun;
                  break
                }
              }

              replication.sync = false;
              ToastService.Small({
                title: 'The next import time of the replication <b class="tc-white"> ' + replication.name + '</b> has been successfully updated',
                color: 'green',
                icon: 'delete'
              }, 1000 * 3);
            })
            .catch(function (reason) {
              replication.sync = false;
              $rootScope.debugInfo(reason);
              ToastService.Small({
                title: 'Failed to sync replication',
                color: 'red',
                icon: 'delete'
              });
            });
      };

      $scope.removeReplication = function (replication) {
        if ($scope.loading) return;
        $rootScope.showLinearProgress('#replicationLoader');

        $scope.modalWindowScope = $scope.$new();
        var inner = '<span class="heavy">Are you sure you want <b>to delete</b> the replication "' + replication.name +'"?</span>';

        ModalWindowService.Open({
          content: inner,
          actions: [
            {
              title: 'I understand. Do it',
              color: 'green',
              fn: function () {
                ReplicationResource.remove({id: replication.id}).$promise
                    .then(function () {
                      $scope.clearActiveReplication();
                      $scope.getReplications();
                      $rootScope.hideLinearProgress('#replicationLoader');
                      ToastService.Small({
                        title: 'The replication <b class="tc-white"> ' + replication.name + '</b> successfully deleted',
                        color: 'green',
                        icon: 'delete'
                      }, 1000 * 3);
                    })
                    .catch(function (reason) {
                      $rootScope.hideLinearProgress('#replicationLoader');
                      $rootScope.debugInfo(reason);
                      ToastService.Small({
                        title: 'Failed to remove replication',
                        color: 'red',
                        icon: 'delete'
                      });
                    });
              }
            },
            {
              title: 'cancel',
              color: 'red',
              fn: function () {
                $rootScope.hideLinearProgress('#replicationLoader');
              }
            }
          ],
          onComplete: function () {
            $scope.modalWindowScope.$destroy();
          }
        });
      };

      //
      $scope.isActiveReplicationSet = function () {
        return !_.isEmpty($scope.activeReplication);
      };

      $scope.setActiveReplication = function (replication) {
        $scope.activeReplication = replication;
        $scope.activeReplication.limit = 20;
        $scope.activeReplication.offset = 0;
        $scope.activeReplication.runs = [];
        $location.search('replication_id', replication.id);
        $rootScope.showLinearProgress('#replicationLoader');

        $scope.activeReplication.loading = true;
        OperatorService.CheckToken(replication.token)
          .then(function (result) {
            $scope.activeReplication.checkedOperator.valid = true;
            $scope.activeReplication.checkedOperator.operator = result.data.ext_id;
          })
          .catch(function (reason) {
            $scope.activeReplication.checkedOperator.valid = false;
          });

        return ReplicationResource.getRuns({id: replication.id}).$promise
            .then(function (runs) {
              for (var i = 0; i < runs.length; i++) {
                $scope.activeReplication.runs.push(jsonReplicationRunToNorm(runs[i]))
              }
              $scope.activeReplication.loading = false;
              $rootScope.hideLinearProgress('#replicationLoader');
            })
            .catch(function (reason) {
              $rootScope.debugInfo(reason, 'silent');
              $scope.activeReplication.loading = false;
              $rootScope.hideLinearProgress('#replicationLoader');
            });
      };

      $scope.activeReplicationNextPage = function () {
        if ($scope.activeReplication.offset + $scope.activeReplication.limit < $scope.activeReplication.runs.length) {
          $scope.activeReplication.offset = $scope.activeReplication.offset + $scope.activeReplication.limit;
        }
      };

      $scope.activeReplicationPrevPage = function () {
        $scope.activeReplication.offset = Math.max($scope.activeReplication.offset - $scope.activeReplication.limit, 0);
      };

      $scope.clearActiveReplication = function () {
        $scope.activeReplication = {};
        $location.search('replication_id', null);
      };

      $scope.routeReplicationId = null;
      if ($routeParams.replication_id) {
        $scope.routeReplicationId = Number($routeParams.replication_id);
      }

      $scope.$on('$routeUpdate', function () {
        if ($scope.routeReplicationId && !$routeParams.replication_id) {
          $scope.clearActiveReplication();
        }
        $scope.routeReplicationId = Number($routeParams.replication_id) || null;
      });

      $scope.getReplications();
    }]);
